// AUTO-GENERATED by scripts/generate-press-releases.mjs — do not edit.
export type PressReleaseInlineNode =
  | { type: 'text'; value: string }
  | { type: 'link'; label: string; href: string }

export type PressReleaseBlock =
  | { type: 'paragraph'; nodes: PressReleaseInlineNode[] }
  | { type: 'blockquote'; nodes: PressReleaseInlineNode[] }
  | { type: 'heading'; level: number; text: string }

export type PressRelease = {
  slug: string
  title: string
  subtitle: string
  date: string
  location: string
  featured: boolean
  excerpt: string
  href: string
  blocks: PressReleaseBlock[]
}

export const pressReleases: PressRelease[] = [

]

export const featuredPressRelease: PressRelease | null = null

export const pressReleaseBySlug: Record<string, PressRelease> = {

}

export const PRESS_RELEASE_PATHS = [] as const
